import { TextCodes } from '@api/types/translation/TextCodes';
import {
  CartCell,
  CartContent,
  CartLineItemColumnNames,
  CartSearch,
  LayoutWithSummary,
  OrderSummary,
} from '@components';
import { useCartContext } from '@context/CartContext';
import { useAppSelector, useInternalRedirect } from '@hooks';
import { useCart /*useCartDraft*/ } from '@hooks/cart/cart.hooks';
import { Box, Button, styled } from '@mui/material';
import { getSpecialPage, getSystemPages } from '@store/app/app.slice';
import { t } from '@translations';
import { useSelector } from 'react-redux';

const CartBox = styled(Box)``;

// COMPONENTS
//------------
export const Cart = () => {
  // const { saveCartAsDraft, saveCartAsDraftStatus } = useCartDraft();
  const { itemCountLabel, itemCount } = useCart();
  const { cartSubTotal, cartTaxTotal, cartTotal } = useCartContext();
  // Go to checkout page
  const redirect = useInternalRedirect();
  const checkoutPage = useAppSelector(getSpecialPage('checkoutPage'));  
  const disableOrderMessage = useSelector(getSystemPages).disableOrderMessage as string;
  const disableOrderProcessing = useSelector(getSystemPages).disableOrderProcessing as boolean;
  const goToCheckout = () => {
    if (checkoutPage) {
      redirect(checkoutPage);
    }
  };

  const buttons = (
    <>
      <Button
        onClick={() => goToCheckout()}
        variant='secondary'
        fullWidth
        disabled={itemCount === 0 || disableOrderProcessing}
      >
        {t(TextCodes.Product.Cart.Proceed)}
      </Button>
    </>
  );
  const summary = (
    <Box sx={{ minWidth: '324px' }}>
      <OrderSummary
        title={t(TextCodes.Product.Cart.Summary)}
        itemCount={itemCountLabel}
        subtotal={cartSubTotal}
        tax={cartTaxTotal}
        total={cartTotal}
        buttons={buttons}
        additionalMessage= {disableOrderProcessing ? disableOrderMessage : ''}
      />
    </Box>
  );

  return (
    <CartBox>
      <CartSearch />
      <LayoutWithSummary side={summary}>
        <CartHeader />
        <CartContent />
      </LayoutWithSummary>
    </CartBox>
  );
};

export const CartHeaderBox = styled(Box)`
  .columns {
    background: transparent;
    padding: 0;
    & > div {
      height: auto;
      font-family: 'Lato';
      font-style: normal;
      font-weight: 700;
      font-size: 16px;
      line-height: 140%;
      letter-spacing: 0.01em;
      color: #1c1c1c;
    }
  }
`;

export const CartHeader = () => {
  return (
    <CartHeaderBox className='cart-header'>
      <Box
        sx={{
          display: { xs: 'none', sm: 'grid' },
          gridTemplateColumns: 'max-content',
        }}
      >
        <CartLineItemColumnNames className='columns' sx={{ gridColumn: 'span 1' }}>
          <CartCell className='image-column'></CartCell>
          <CartCell className='long'>{t(TextCodes.Product.Cart.Products)}</CartCell>
          <CartCell
            sx={{
              display: { xs: 'none', md: 'flex', lmd: 'none', lg: 'flex' },
            }}
          >
            {t(TextCodes.Order.Details.UnitPriceColumn)}
          </CartCell>
          <CartCell
            sx={{
              display: { xs: 'none', lx: 'flex' },
            }}
          >
            {t(TextCodes.Order.Details.DiscountColumn)}
          </CartCell>
          <CartCell>{t(TextCodes.Order.Details.NetPriceColumn)}</CartCell>
          <CartCell
            className='quantity'
            sx={{
              display: { xs: 'none', lsm: 'flex' },
            }}
          >
            {t(TextCodes.Order.Details.QuantityColumn)}
          </CartCell>
          <CartCell>{t(TextCodes.Order.Details.TotalColumn)}</CartCell>
          <CartCell className='actions-with-favorites'></CartCell>
        </CartLineItemColumnNames>
      </Box>
    </CartHeaderBox>
  );
};
